// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PaymentCardMaskedNumber_paymentCard_graphql = require("../../../__generated__/PaymentCardMaskedNumber_paymentCard_graphql.bs.js");

let convertFragment = PaymentCardMaskedNumber_paymentCard_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PaymentCardMaskedNumber_paymentCard_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PaymentCardMaskedNumber_paymentCard_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PaymentCardMaskedNumber_paymentCard_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PaymentCardMaskedNumber_paymentCard_graphql.node, convertFragment, fRef);
}

let CardFragment_cardBrandV5_decode = PaymentCardMaskedNumber_paymentCard_graphql.Utils.cardBrandV5_decode;

let CardFragment_cardBrandV5_fromString = PaymentCardMaskedNumber_paymentCard_graphql.Utils.cardBrandV5_fromString;

let CardFragment = {
  cardBrandV5_decode: CardFragment_cardBrandV5_decode,
  cardBrandV5_fromString: CardFragment_cardBrandV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PaymentCardMaskedNumber(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let card = RescriptRelay_Fragment.useFragment(PaymentCardMaskedNumber_paymentCard_graphql.node, convertFragment, props.card);
  let match = card.brand;
  let maskedNumber;
  maskedNumber = match === "AMERICAN_EXPRESS" || match === "VISA" || match === "DISCOVER" || match === "MASTERCARD" ? (
      match === "AMERICAN_EXPRESS" ? `**** ****** *` + card.lastFour : `**** **** **** ` + card.lastFour
    ) : `**** **** **** ` + card.lastFour;
  return JsxRuntime.jsx("div", {
    children: maskedNumber,
    className: className
  });
}

let make = PaymentCardMaskedNumber;

exports.CardFragment = CardFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
